import React from "react";
import {
  TitleField,
  ShortDescriptionField,
  DescriptionField,
  ObjectsField
} from "./fields";
import { withTmpField } from "./hocs";
import { Form, FormError, SubmitButton, CancelButton } from "app/forms";
import { reduxForm } from "redux-form";
import styled from "styled-components";
import { injectIntl } from "react-intl";
import { compose } from "recompose";

const ButtonsWrapper = styled.div`
  margin: 2em 0;
`;

const Buttons = withTmpField(props => {
  const { tmpField, onCancelClick, valid, submitting, intl } = props;
  if (tmpField) return null;
  return (
    <ButtonsWrapper>
      <SubmitButton
        valid={valid}
        submitting={submitting}
        text={intl.formatMessage({
          id: "proposal.save",
          defaultMessage: "Save proposal"
        })}
        className="pt-intent-primary"
      />
      <CancelButton
        onClick={onCancelClick}
        text={intl.formatMessage({
          id: "text.cancel",
          defaultMessage: "Cancel"
        })}
      />
    </ButtonsWrapper>
  );
});

const ProposalForm = props => {
  const {
    handleSubmit,
    submitting,
    valid,
    error,
    onCancelClick,
    topicId,
    tmpField,
    intl
  } = props;
  return (
    <Form onSubmit={handleSubmit}>
      <TitleField />
      {/* maxLength was decided in this issue 
      https://geocode.igd.fraunhofer.de/smarticipate/web-interface/issues/24 */}
      <ShortDescriptionField rows={2} maxLength={150} />
      <DescriptionField rows={5} maxLength={1000} />
      <ObjectsField topicId={topicId} />
      <FormError error={error} submitting={submitting} />
      {!tmpField && (
        <Buttons
          onCancelClick={onCancelClick}
          valid={valid}
          submitting={submitting}
          intl={intl}
        />
      )}
    </Form>
  );
};

export default compose(
  reduxForm({
    form: "proposal"
  }),
  injectIntl
)(ProposalForm);



// WEBPACK FOOTER //
// ./src/app/proposals/ProposalForm.js